module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fc-Ga-Hc-Ic-Jb.08ec22f5.png";